import { FC, useState } from "react";
import { ChatFileProps } from "./types";
import { Row } from "../../../../../components/containers";
import ChatFileImage from "./chat-file-image";
import ChatFileUnknown from "./chat-file-unknown";
import { JustifyContent } from "../../../../../components/containers/types";
import { getExt } from "../../../../../utils";

const ChatFile: FC<ChatFileProps> = ({
  file,
  status,
  isMe = false,
  isSidePanel,
}) => {
  const [ext] = useState<string>(
    !file.local ? getExt(file.filename) : file.ext
  );

  return (
    <Row
      style={{ width: "100%", marginBottom: 4 }}
      justifyContent={!isMe ? JustifyContent.End : JustifyContent.Start}
    >
      {ext === ".png" ||
      ext === ".jpg" ||
      ext === ".jpeg" ||
      ext === ".webp" ? (
        <ChatFileImage status={status} file={file} isSidePanel={isSidePanel} />
      ) : (
        <ChatFileUnknown
          file={file}
          isMe={isMe}
          status={status}
          isSidePanel={isSidePanel}
        />
      )}
    </Row>
  );
};

export default ChatFile;
